"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeepCompareMemo = void 0;
const react_1 = require("react");
const react_fast_compare_1 = __importDefault(require("react-fast-compare"));
function useDeepCompareMemo(memoized) {
    const value = react_1.useRef(memoized);
    if (!react_fast_compare_1.default(value.current, memoized)) {
        value.current = memoized;
    }
    return value.current;
}
exports.useDeepCompareMemo = useDeepCompareMemo;
//# sourceMappingURL=useDeepCompareMemo.js.map